<template>
    <div class="version-package-page">
        <div class="version-package-page__header">版本套餐</div>
        <div class="version-package-page__body">
            <version-package-plans :collapsible-compare="false" />
        </div>
    </div>
</template>

<script>
import VersionPackagePlans from './components/Plans'

export default {
    name: 'version-package',
    components: { VersionPackagePlans }
}
</script>

<style scoped lang="scss">
.version-package-page {
    background: #edf0f9;
    min-height: calc(100vh - 164px);
    padding: 0;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.version-package-page__header {
    height: 58px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 20px;
    font-weight: 600;
    color: #2f3a4f;
    margin-bottom: 12px;
    border: 1px solid #e9edf6;
    line-height: 1;
}

.version-package-page__body {
    position: relative;
    background: #fff;
    border-radius: 10px;
    padding: 28px 64px 36px;
    border: 1px solid #e9edf6;
    box-sizing: border-box;
}

@media (max-width: 1200px) {
    .version-package-page__body {
        padding: 24px 40px 32px;
    }
}
</style>
